import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import api from "../../Utils/api";
import { Card, Form, Button, Col, Row, InputGroup } from "react-bootstrap";

export default function UserProfile() {
  const [validated, setValidated] = useState(false);
  
  const [formData, setFormData] = useState({
    user_id: 0,
    user_name: "",
    old_password: "",
    new_password: "",
    //confirm_password: "",
  });
 
 
  useEffect(() => {
    getSingleUser();
  }, []);
  
  // Fetch all Users
  const getSingleUser = () => {
    const USER_ID = localStorage.getItem("user_ID");
    api
      .get(`User/ByID?UserID=${USER_ID}`)
      .then((result) => {
        const UserData = result.data.data;
        setFormData({
          user_id: UserData.userID,
          user_name: UserData.userName,
          old_password: UserData.password,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };
   
const validatePassword = (password = "") => {
  const minLength = password.length >= 6;
  const hasUpper = /[A-Z]/.test(password);
  const hasSpecial = /[!@#$%^&*(),.?":{}|<>]/.test(password);

  return {
    minLength,
    hasUpper,
    hasSpecial,
    isValid: minLength && hasUpper && hasSpecial,
  };
};

const getPasswordStrength = (password = "") => {
  let score = 0;

  if (password.length >= 6) score++;
  if (/[A-Z]/.test(password)) score++;
  if (/[0-9]/.test(password)) score++;
  if (/[!@#$%^&*]/.test(password)) score++;

  if (score <= 2) return "Weak";
  if (score === 3) return "Medium";
  return "Strong";
};

const passwordCheck = validatePassword(formData?.new_password ?? "");
const strength = getPasswordStrength(formData?.new_password ?? "");
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };

  // Insert & Update Data
  const handleSubmit = (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    setValidated(true);
    
        if (!formData.old_password) {
        toast.error("Old password is required");
        return;
      }

      // if (formData.new_password !== formData.confirm_password) {
      //   toast.error("New Password and Confirm Password must match");
      //   return;
      // }

      if (!passwordCheck.isValid) {
        toast.error("Password must be strong");
        return;
      }
    if (form.checkValidity() === false) {
      event.stopPropagation();
    } else {
      const data = {
        userID: formData.user_id,
        userName: formData.user_name,
        Password: formData.new_password,
      };
      api
        .patch("User/UpdateUserProfile", data)
        .then((result) => {
          setValidated(false); // Reset validation state
          formData?.user_id === 0
            ? toast.success(result.data.message)
            : toast.success(result.data.message);
        })
        .catch((error) => {
          console.log(error);
          toast.error("An error occurred");
        });
    }
  };

  return (
    <>
      <ToastContainer />
      <Card>
        <Card.Header>
          <span>User Profile</span>
        </Card.Header>
        <Card.Body>
          <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <Row>
              <Col md={4} sm={2} lg={4}>
                <Form.Group controlId="user_name">
                  <strong htmlFor="user_name">User Name</strong>
                  <InputGroup className="mb-3">
                    <InputGroup.Text id="basic-addon1">
                      <i class="fas fa-user"></i>
                    </InputGroup.Text>
                    <Form.Control
                      type="text"
                      name="user_name"
                      placeholder="Enter User Name"
                      value={formData.user_name}
                      onChange={handleInputChange}
                      required
                      disabled
                    />
                    {validated && !formData.client_name && (
                      <div className="invalid-feedback">
                        Please Enter User Name.
                      </div>
                    )}
                  </InputGroup>
                </Form.Group>
              </Col>
              <Col md={4} sm={2} lg={4}>
                <Form.Group controlId="password">
                <strong htmlFor="password">Old Password</strong>
                  <InputGroup className="mb-3">
                    <InputGroup.Text id="basic-addon1">
                      <i class="fas fa-lock"></i>
                    </InputGroup.Text>
                   <Form.Control
                      type="password"
                      name="old_password"
                      placeholder="Enter Old Password"
                      value={formData.old_password}
                      onChange={handleInputChange}
                      required
                    />
                    {validated && !formData.client_name && (
                      <div className="invalid-feedback">
                        Please Enter Password.
                      </div>
                    )}
                  </InputGroup>
                </Form.Group>
              </Col>
              <Col md={4} sm={2} lg={4}>
                <Form.Group controlId="password">
                <strong htmlFor="password">New Password</strong>
                  <InputGroup className="mb-3">
                    <InputGroup.Text id="basic-addon1">
                      <i class="fas fa-lock"></i>
                    </InputGroup.Text>
                    <Form.Control
                        type="password"
                        name="new_password"
                        placeholder="Enter New Password"
                        value={formData.new_password}
                        onChange={handleInputChange}
                        required
                      />
                      {validated && !formData.client_name && (
                      <div className="invalid-feedback">
                        Please Enter Password.
                      </div>
                    )}
                  </InputGroup>
                </Form.Group>
              </Col>

                 {/* <Col md={4} sm={2} lg={4}>
                <Form.Group controlId="password">
                <strong htmlFor="password">Confirm Password</strong>
                  <InputGroup className="mb-3">
                    <InputGroup.Text id="basic-addon1">
                      <i class="fas fa-lock"></i>
                    </InputGroup.Text>
                    <Form.Control
                      type="password"
                      name="confirm_password"
                      placeholder="Confirm Password"
                      value={formData.confirm_password}
                      onChange={handleInputChange}
                      required
                    />
                    {validated && !formData.client_name && (
                      <div className="invalid-feedback">
                        Please Enter Confirm Password.
                      </div>
                    )}
                  </InputGroup>
                </Form.Group>
              </Col> */}




            </Row>
            <div style={{ fontSize: "13px" }}>
                <div style={{ color: passwordCheck.minLength ? "green" : "red" }}>
                  • Minimum 6 characters
                </div>
                <div style={{ color: passwordCheck.hasUpper ? "green" : "red" }}>
                  • At least one uppercase letter
                </div>
                <div style={{ color: passwordCheck.hasSpecial ? "green" : "red" }}>
                  • At least one special character
                </div>
              </div>
              <div>
                Strength:{" "}
                <strong
                  style={{
                    color:
                      strength === "Strong"
                        ? "green"
                        : strength === "Medium"
                        ? "orange"
                        : "red",
                  }}
                >
                  {strength}
                </strong>
              </div>
            <div className="card-footer margin_top10">
              <Button type="submit" variant="primary" className="mb-20px">
                {formData?.user_id > 0 ? "Update" : "Save"}
              </Button>
            </div>
          </Form>
        </Card.Body>
      </Card>
    </>
  );
}
